import { render, staticRenderFns } from "./AgentsStats.vue?vue&type=template&id=2c9bc9a6&scoped=true"
import script from "./AgentsStats.vue?vue&type=script&lang=js"
export * from "./AgentsStats.vue?vue&type=script&lang=js"
import style0 from "./AgentsStats.vue?vue&type=style&index=0&id=2c9bc9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9bc9a6",
  null
  
)

export default component.exports